import { Divider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import AddIcon from '@material-ui/icons/Add';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import RemoveIcon from '@material-ui/icons/Delete';
import DropDownIcon from '@material-ui/icons/VerticalAlignBottom';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { getEnvVariable } from '../../../modules/environmentalList';
import { GetData, PostData } from '../helpers/requests';
import { GetFetchProps } from '../../modules/header';
import { OldPostMutiFormData } from '../../../core/controls/helpers/requests';
import DefaultSettings from './settings';
import { useParams } from 'react-router-dom';



export default function MultipleFileUpload({ edit, fieldValues, props, ismultiple = true, name, IsFilenet = false, ischildAttachments = false, value, handleFieldValue }) {
    if (ischildAttachments)
        ischildAttachments = getEnvVariable('AllowChildDocuments') == "Y" ? true : false;
    const [multiplefiles, setMultipleFiles] = useState(value || [])
    // const [NoteView, setNoteView] = useState(props.dataItem || [])
    const fileInput = useRef(null)
    const params = useParams()

    useEffect(() => {
        setMultipleFiles(value)
    }, [value])

    const handleFileUpload = (event) => {
        let file = []
        event.preventDefault();
        if (fileInput && fileInput.current) {
            const fname = fileInput.current.files[0].name;
            const size = fileInput.current.files[0].size;
            toBase64(event)
                .then(result => {
                    var e = {
                        target: {
                            name: fname,
                            value: result
                        }
                    }
                    let attach = result.split(',')
                    if (attach.length === 2)
                        file.push({ UploadType: 'U', ContentStr: attach[1], FileName: fname, Size: size, FileType: attach[0] });
                    let files = [...multiplefiles, ...file];

                    //500MB
                    if (size > 500000000) { //change to 5 MB
                        if (DefaultSettings.getAlert())
                            DefaultSettings.getAlert().show('Uploading size exceeded 500MB', 'error');
                    } else {
                        setMultipleFiles(files)
                        let events = { target: { value: files, name: name, checked: false }, currentTarget: { dataset: null } }
                        handleFieldValue(events);
                    }

                }).catch(ex => console.log(ex));
        }
    }
    const uploadFile = (e, parentid, childid) => {// parent parameter
        let files = e.target.files;
        if (files && files.length > 0) {
            uploadFileWrapper(files, parentid, childid);
        }
    }/*  */

    const uploadFileWrapper = (files, parentid) => {
        let url = getEnvVariable('Application') + `/api/FileSystem/${params.Id ? params.Id + '/Upload' : 'Upload'}?parentid=${params.Id}&sitePermitTypeId=${params.Id}&attachmentType=${fieldValues['AttachmentTypeId']}`;
        let predetails = []
        var formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('files', files[i], files[i].name);
        }
        OldPostMutiFormData(url, formData, true, true, '').then(response => {
            let res = response
            if (res && res.length > 0)
                for (let i = 0; i < res.length; i++) {
                    let pdobj = {
                        FileName: res[i].fileName, ContentType: res[i].fileName.split(".").pop(), Size: res[i].size, FileReference: res[i].fileReference,
                        fileName: res[i].fileName, extension: files[i].type, fileType: files[i].type, guid: res[i].fileReference, size: res[i].size,

                    }
                    if (parentid) {
                        pdobj.ParentAttachmentDetailId = parentid;
                        var parentFile = multiplefiles.find(f => f.Id == parentid);
                        if (parentFile) {
                            let childAttachmentDetails = parentFile.ChildAttachmentDetails || []
                            childAttachmentDetails.push(pdobj)
                            parentFile.ChildAttachmentDetails = childAttachmentDetails;
                            predetails.push(pdobj)
                        }
                    }
                    else {
                        predetails.push(pdobj);
                    }
                }
            let events = { target: { value: [...multiplefiles, ...predetails], name: name, checked: false }, currentTarget: { dataset: null } }
            handleFieldValue(events);

        }).catch(ex => {
            console.error(ex)
        })
    }


    const toBase64 = (event) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        })
    };

    const extensionToMime = (ext) => {
        switch ((ext || '').toLowerCase()) {
            case 'jpg': return 'image/jpg';
            case 'jpeg': return 'image/jpeg';
            case 'png': return 'image/png';
            case 'gif': return 'image/gif';
            case 'bmp': return 'image/bmp';
            case 'svg': return 'image/svg+xml';
            case 'webp': return 'image/webp';
            case 'pdf': return 'application/pdf';
            case 'txt': return 'text/plain';
            case 'doc': return 'application/msword';
            case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            case 'xls': return 'application/vnd.ms-excel';
            case 'xlsx': return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            case 'ppt': return 'application/vnd.ms-powerpoint';
            case 'pptx': return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
            case 'csv': return 'text/csv';
            case 'zip': return 'application/zip';
            default: return 'application/octet-stream';
        }
    }


    const getContentType = (file) => {
        let ct = file.FileType || file.ContentType;
        if (ct && ct.includes('/')) return ct;
        const inferred = (file.FileName && file.FileName.split('.').pop()) || ct;
        return extensionToMime(inferred);
    }

    const handleDelete = (file) => {
        // Support both top-level and child attachments, and avoid server calls with undefined Ids
        let tempfiles = [...(multiplefiles || [])];

        const removeFromParent = (parentId, child) => {
            const parentIdx = tempfiles.findIndex(f => f && f.Id === parentId);
            if (parentIdx > -1) {
                const parent = { ...tempfiles[parentIdx] };
                parent.ChildAttachmentDetails = (parent.ChildAttachmentDetails || []).filter(cd => {
                    return cd !== child && cd.Id !== child?.Id && cd.FileReference !== child?.FileReference;
                });
                tempfiles[parentIdx] = parent;
            }
        };

        if (file && file.ParentAttachmentDetailId) {
            // Child document case: just update local state; server-side delete will be handled after save with real Ids
            removeFromParent(file.ParentAttachmentDetailId, file);
            const events = { target: { value: tempfiles, name: name, checked: false }, currentTarget: { dataset: null } };
            setMultipleFiles(tempfiles);
            handleFieldValue(events);
            return;
        }

        // Top-level document
        const hasServerId = !!(file && file.Id);
        if (!hasServerId) {
            // Not persisted yet; remove locally only
            tempfiles = tempfiles.filter(f => f !== file && f.Id !== file?.Id && f.FileReference !== file?.FileReference);
            const events = { target: { value: tempfiles, name: name, checked: false }, currentTarget: { dataset: null } };
            setMultipleFiles(tempfiles);
            handleFieldValue(events);
            return;
        }

        // Persisted: call API then update local state
        const events = { target: { value: tempfiles.filter(f => f.Id !== file.Id), name: name, checked: false }, currentTarget: { dataset: null } };
        const url = getEnvVariable('Admin') + '/api/Files/RemoveFile/' + file.Id;
        GetData(url).then(resp => {
            if (resp) {
                setMultipleFiles(events.target.value)
                handleFieldValue(events);
                if (DefaultSettings.getAlert()) DefaultSettings.getAlert().show('Attachment removed successfully', 'success');
            }
        }).catch(err => console.error('Delete failed', err))
    }


    // Ensures we always have a valid data URL (original issue: missing comma after base64 header for newly added files)
    const buildDataUrl = (fileTypeHeader, base64Data) => {
        if (!base64Data) return '';
        // If server already returned a full data URL just pass it through
        if (fileTypeHeader && fileTypeHeader.startsWith('data:') && fileTypeHeader.includes(',')) {
            // Some APIs might already concatenate header+data; detect and return
            if (fileTypeHeader.split(',')[1]) return fileTypeHeader; // already has data portion
        }
        let header = fileTypeHeader || 'data:application/octet-stream;base64';
        if (!header.startsWith('data:')) {
            header = `data:${header}`;
        }
        if (!/;base64$/i.test(header) && !/;base64,/i.test(header)) {
            header += ';base64';
        }
        // Guarantee exactly one comma separator
        if (!header.endsWith(',')) header += ',';
        return header + base64Data;
    }

    const DownloadAttachment = (Name, linkSource, ContentStr, filetype) => {
        // Base64 direct download fallback
        if (!linkSource) linkSource = (filetype || '') + (ContentStr || '');
        const a = document.createElement('a');
        a.href = linkSource;
        a.download = Name || 'Attachment';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    const fetchAndDownload = async (url, filename) => {
        try {
            // Use noHeader=true so we don't send Content-Type: application/json for binary
            const resp = await fetch(url, { method: 'GET', ...GetFetchProps(false, true) });
            if (!resp.ok) {
                throw new Error('HTTP ' + resp.status);
            }
            const blob = await resp.blob();
            if (!blob || blob.size === 0) {
                if (DefaultSettings.getAlert()) DefaultSettings.getAlert().show('Empty file content.', 'warning');
                return;
            }
            const objectUrl = URL.createObjectURL(blob);
            DownloadAttachment(filename, objectUrl);
            setTimeout(() => URL.revokeObjectURL(objectUrl), 4000);
        } catch (err) {
            console.error('Authenticated file fetch failed', err);
            if (DefaultSettings.getAlert()) DefaultSettings.getAlert().show('Download failed.', 'error');
        }
    }


    // New unified download entry
    const downloadAttachments = (file) => {
        if (!file) return;
        console.log('Download request', file);
        if (file.FileReference) {
            const ImageExtensions = getEnvVariable('ImageExtensions');
            const AttachmentExtensions = getEnvVariable('AttachmentExtensions');
            let folder = "";
            // Align with working reference screenshot: filename (lower camel), filetype (mime), contentType (extension)
            const extension = (file.FileName || '').split('.').pop();
            if (ImageExtensions.includes(extension)) {
                folder = "Images";
            } else if (AttachmentExtensions.includes(extension)) {
                folder = "Attachments";
            }
            const fileData = {
                fileReference: file.FileReference,
                filetype: getContentType(file), // full mime type
                Id: file.Id,
                contentType: extension,        // e.g. 'pdf'
                filename: file.FileName,
                folder: folder
            };
            const refUrl = getEnvVariable('Sidebar') + `/api/FileSystem/${file.Id}/DownloadRef`;
            PostData(refUrl, fileData)
                .then(dldref => {
                    console.log('DownloadRef response', dldref);
                    // Accept multiple casings or direct string GUID
                    const fid = (dldref && (dldref.FileId || dldref.fileId || dldref.FILEID || dldref.fileID)) || (typeof dldref === 'string' ? dldref : null);
                    if (fid) {
                        const contentUrl = getEnvVariable('Sidebar') + `/api/FileSystem/DownloadContent/${fid}`;
                        fetchAndDownload(contentUrl, file.FileName || 'Attachment');
                    } else {
                        if (DefaultSettings.getAlert()) DefaultSettings.getAlert().show('Download reference not returned.', 'warning');
                    }
                })
                .catch(err => {
                    console.error('DownloadRef failed', err);
                    if (DefaultSettings.getAlert()) DefaultSettings.getAlert().show('Download failed.', 'error');
                });
        } else if (file.Id > 0 && file.IsAdmin === 'Y') {
            // Company admin files path
            GetData(getEnvVariable('Admin') + `/api/CompanyFiles/Download/${file.Id}`)
                .then(resp => {
                    if (resp && resp.FileId) {
                        fetchAndDownload(getEnvVariable('Admin') + `/api/CompanyFiles/DownloadContent/${resp.FileId}`, file.FileName || 'Attachment');
                    } else if (DefaultSettings.getAlert()) {
                        DefaultSettings.getAlert().show('Company file not found for download.', 'warning');
                    }
                })
                .catch(err => {
                    console.error('CompanyFiles download failed', err);
                    if (DefaultSettings.getAlert()) DefaultSettings.getAlert().show('Download failed.', 'error');
                })
        } else if (!file.Id && file.ContentStr && file.FileType) {
            // Unsaved base64 file
            DownloadAttachment(file.FileName || 'Document', null, file.ContentStr, file.FileType);
        }
    }

    // Removed old directFileFetch multi-endpoint logic (not needed with explicit ref + company paths)

    const canShowActions = (file) => !!(file && file.Id); // Only show download/delete for persisted files (Edit/View screens)

    console.log(IsFilenet);
    return (
        <div className='col-12 row m-2' style={{ height: '300px', overflow: 'auto' }}>
            <Paper elevation={1} className="col-12">
                {multiplefiles && multiplefiles.length === 0 && <div className="text-center ">
                    <AttachFileIcon color="default" style={{ fontSize: '60px' }} /><br />
                    <div classes="text-secondary">No attachments have been added</div><br />
                    {edit && <Button variant="contained" component="label" color="primary"> <AddIcon /> Add Attachment
                        <input
                            type="file"
                            ref={fileInput}
                            onChange={(e) => IsFilenet === true ? uploadFile(e) : handleFileUpload(e)}
                            hidden
                        />
                    </Button>}
                </div>
                }
                {multiplefiles && multiplefiles.length > 0 &&
                    <div>
                        <h6 className="pt-4 col fw-bold">Attachments&nbsp;&nbsp;
                            {/* {multiplefiles && multiplefiles.length > 0 && <IconButton edge="end" color="primary" onClick={() => zipAttachDownload()}>
                                <ArchiveIcon />
                            </IconButton>} */}
                        </h6>
                        <br />
                        <Divider />
                        {edit && ismultiple && <Button component="label" > <AddIcon color="primary" /> Add Attachment
                            <input
                                type="file"
                                ref={fileInput}
                                onChange={IsFilenet === true ? uploadFile : handleFileUpload}
                                hidden
                            />
                        </Button>}
                        <Divider /></div>
                }
                {multiplefiles && multiplefiles.length > 0 && <Fragment>
                    <List>
                        <ListItem dense>
                            <ListItemText alignItems="flex-start">
                                <Typography component="span" variant="subtitle2" color="primary">Name</Typography>
                            </ListItemText>
                            <ListItemSecondaryAction>
                                <Typography component="span" variant="subtitle2" color="primary">Actions</Typography>
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                    <Divider />
                    <List>
                        <Paper elevation={1} className="col-12">
                            {ischildAttachments && (multiplefiles || []).filter(f => !f.ParentAttachmentDetailId).map((file, i) => (
                                <ListItem key={i} dense>
                                    <Paper elevation={0} className="col-12">
                                        <ListItemText alignItems="flex-start">
                                            {file.FileName || file.Id || 'Document ' + (i + 1)}
                                            <span className='float-end'>
                                                {edit && ischildAttachments && <IconButton edge="end" color="primary" component="label">
                                                    <AddIcon className='float-end' size="small" />
                                                    <input
                                                        type="file"
                                                        className='float-end'
                                                        ref={fileInput}
                                                        onChange={(e) => IsFilenet ? uploadFile(e, file.Id) : handleFileUpload(file.Id)}
                                                        hidden
                                                    />
                                                </IconButton>}
                                                {canShowActions(file) && <IconButton edge="end" color="primary" onClick={() => downloadAttachments(file)}><DropDownIcon /></IconButton>}
                                                {edit && canShowActions(file) && <IconButton edge="end" color="secondary" onClick={() => handleDelete(file)}>{fieldValues && fieldValues.FileDetails[0] && fieldValues.FileDetails[0].Id != '' && <RemoveIcon />}</IconButton>}
                                            </span>
                                            {(file.ChildAttachmentDetails || []).map((child, ci) => (
                                                <ListItem key={ci} dense>
                                                    <Paper elevation={1} className="col-12">
                                                        <ListItemText alignItems="flex-start">{child.FileName || child.Id || 'Document ' + (ci + 1)}</ListItemText>
                                                        <ListItemSecondaryAction>
                                                            {canShowActions(child) && <IconButton edge="end" color="primary" onClick={() => downloadAttachments(child)}><DropDownIcon /></IconButton>}
                                                            {edit && canShowActions(child) && <IconButton edge="end" color="secondary" onClick={() => handleDelete(child)}>{fieldValues && fieldValues.FileDetails[0] && fieldValues.FileDetails[0].Id != '' && <RemoveIcon />}</IconButton>}
                                                        </ListItemSecondaryAction>
                                                    </Paper>
                                                </ListItem>
                                            ))}
                                        </ListItemText>
                                    </Paper>
                                </ListItem>
                            ))}
                            {!ischildAttachments && (multiplefiles || []).map((file, i) => (
                                <ListItem key={i} dense>
                                    <ListItemText alignItems="flex-start">{file.FileName || file.Id || 'Document ' + (i + 1)}</ListItemText>
                                    <ListItemSecondaryAction>
                                        {canShowActions(file) && <IconButton edge="end" color="primary" onClick={() => downloadAttachments(file)}><DropDownIcon /></IconButton>}
                                        {edit && canShowActions(file) && <IconButton edge="end" color="secondary" onClick={() => handleDelete(file)}>{fieldValues && fieldValues.FileDetails[0] && fieldValues.FileDetails[0].Id != '' && <RemoveIcon />}</IconButton>}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </Paper>
                    </List>
                </Fragment>}
            </Paper>
        </div >



    );
}

